import React from 'react';
import { Image } from 'cloudinary-react';

const CustomImage = props => <Image cloudName="dwjzxeiqm" {...props} />;

export default CustomImage;
